export default function PageNotFound() {
  const hostname = process.env.REACT_APP_APIM_HOST || window.location.origin;
  window.location.href = `${hostname}/admin/404`;
  return null;
}



// WEBPACK FOOTER //
// ./src/pages/PageNotFoundPage.js